import { BRANDCLUB_BRAND_ID } from "@brandclub/common-ui";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../redux/hooks";
import { isImageSrcExist } from "../utils/StringUtils";

const DEFAULT_FAVICON = "https://media.brandclub.com/brandclub/def_favicon.ico";

// This component stay in the top level of any route
// and it is used to change the favicon of the page based on the brandId

const FaviconManager = () => {
  const appConfig = useAppSelector(({ appConfig }) => appConfig);
  const brandIdForDomain = appConfig?.domainConfig?.brandId;

  const IS_CUSTOM_BRAND = brandIdForDomain !== BRANDCLUB_BRAND_ID;

  const params = useParams();
  const { brandId: brandIdFromParam } = params;

  // trick: brandId can be string or number, always convert to number and put it in the useEffect dependency
  const brandId =
    brandIdForDomain && brandIdForDomain !== BRANDCLUB_BRAND_ID
      ? brandIdForDomain
      : brandIdFromParam;
  const numberBrandId = brandId ? +brandId : brandId;

  const [favicon, setFavicon] = useState<string | null>(
    numberBrandId
      ? `https://media.brandclub.com/brand_custom/${numberBrandId}/favicon.png`
      : null,
  );

  useEffect(() => {
    const getFavicon = async () => {
      const customFavicon = `https://media.brandclub.com/brand_custom/${numberBrandId}/favicon.png`;
      const imageValid = await isImageSrcExist(customFavicon);
      setFavicon(imageValid ? customFavicon : DEFAULT_FAVICON);
    };

    if (numberBrandId) {
      getFavicon();
    } else {
      setFavicon(DEFAULT_FAVICON);
    }
  }, [numberBrandId]);

  if (!IS_CUSTOM_BRAND) {
    return null;
  }

  if (!favicon) {
    return null;
  }

  return (
    <>
      <Helmet>
        <link rel="icon" href={favicon} />
        <title>{appConfig?.brandAppConfig?.appName || ""}</title>
      </Helmet>
    </>
  );
};
export default FaviconManager;
